import DrawBottom from '@/components/DrawBottom'
import {
  FormAddress,
  FormButton,
  FormGroup,
  FormInput,
  FormTextRequire,
} from '@/components/Form'
import { IconCompared } from '@/components/Icon/IconProductDetail'
import ImageOptimize from '@/components/ImageOptimize'
import { LoadingIndicator } from '@/components/LoadingIndicator'
import OriginPrice from '@/components/Price/OriginPrice'
import PreOrder from '@/components/Price/PreOrder'
import SalePrice from '@/components/Price/SalePrice'
import ProductLabel from '@/components/ProductLabel'
import { PageType, ProductStockStatus } from '@/constants'
import { useAuth, useCart, useNotification, useStore } from '@/containers'
import { IconCheckedSuccess, SelectedIcon } from '@/styles/Icon'
import type {
  GiftItems,
  OrderService,
  OtherOffers,
  Product,
  ProductCompare,
  ProductDetail,
} from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { translateSchema } from '@/utils/validations'
import clsx from 'clsx'
import { Form, Formik } from 'formik'
import isNil from 'lodash/isNil'
import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import Link from 'next/link'
import {
  useMemo,
  useState,
  type Dispatch,
  type FC,
  type SetStateAction,
} from 'react'
import { toast } from 'react-toastify'
import { Autoplay, FreeMode, Grid } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import AccompaniedService from '../AccompaniedService'
import Gift from '../Gift'

const StarRatings = dynamic(() => import('react-star-ratings'), {
  ssr: false,
})
const OutstandingFeature = dynamic(() => import('../OutstandingFeature'), {
  ssr: false,
})
interface Props {
  entrySummaryData: ProductDetail
  checkSaleArea: boolean
  isOpenContact?: boolean
  setListService: Dispatch<SetStateAction<OrderService[]>>
  setIsOpenContact: Dispatch<SetStateAction<boolean>>
  setIsOpenComparePopup: Dispatch<SetStateAction<boolean>>
  listService?: OrderService[]
  setProductCompares: (newValue: ProductCompare[]) => void
  setListGift: Dispatch<SetStateAction<GiftItems[] | undefined>>
  listGift?: GiftItems[] | undefined
  setListOffer: Dispatch<SetStateAction<OtherOffers[] | undefined>>
  listOffer?: OtherOffers[] | undefined
  productCompares: ProductCompare[]
  pickUpInStore: boolean
  setPickUpInStore: Dispatch<SetStateAction<boolean>>
  priceWithService: number
  setPriceWithService: Dispatch<SetStateAction<number>>
  isOutOfStock: boolean
  handleInstallment: (
    product: Product | ProductDetail,
    type: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => Promise<any>
}
export const EntrySummary: FC<Props> = ({
  entrySummaryData,
  isOpenContact,
  setIsOpenContact,
  setListService,
  listService,
  setListGift,
  listGift,
  setListOffer,
  listOffer,
  setProductCompares,
  productCompares,
  setIsOpenComparePopup,
  setPickUpInStore,
  pickUpInStore,
  isOutOfStock,
  priceWithService,
  setPriceWithService,
}: Props) => {
  const t = useTranslations('ProductDetail')
  const {
    // user,
    storeList,
    storeSelected,
    setStoreSelected,
    globalLoading,
  } = useAuth()
  const { sendContact, isPreOrder } = useCart()
  const { systemConfig } = useNotification()
  const [isOpenDraw, setIsOpenDraw] = useState(false)
  const { provinces } = useStore()
  const stockStatus = useMemo(() => {
    if (entrySummaryData?.stockStatus) {
      if (entrySummaryData.stockStatus === ProductStockStatus.ARRIVING) {
        return ProductStockStatus.IN_STOCK
      }
      return entrySummaryData?.stockStatus
    }
    return ProductStockStatus.IN_STOCK
  }, [entrySummaryData])

  const star = (point: number | undefined) => {
    return (
      <StarRatings
        starRatedColor='#FFCD4B'
        numberOfStars={5}
        rating={point == 0 || point == undefined ? 5 : point}
        starDimension='12px'
        starSpacing='1px'
        svgIconPath='M20 0L26.1803 13.1672L40 15.2786L30 25.5279L32.3607 40L20 33.1672L7.63932 40L10 25.5279L0 15.2786L13.8197 13.1672L20 0Z'
        svgIconViewBox='0 0 40 40'
      />
    )
  }
  // const expectPrice = entrySummaryData?.finalPrice / 6
  // const percent = Math.ceil(
  //   100 - (entrySummaryData?.finalPrice / entrySummaryData?.price) * 100
  // )
  const isCompare = () => {
    return !isNil(productCompares.find(e => e._id === entrySummaryData?._id))
  }
  const handleAddToCompare = () => {
    const productCompared = productCompares.find(
      e => e.catId && e.catId !== entrySummaryData?.catId
    )
      ? [{}, {}, {}]
      : productCompares
    if (isCompare()) {
      setProductCompares(
        productCompared
          .map(e => (e._id && e._id === entrySummaryData?._id ? {} : e))
          .sort((a, b) => {
            if (Object.keys(a).length === 0 && Object.keys(b).length === 0) {
              return 0
            }
            if (Object.keys(a).length === 0) return 1
            if (Object.keys(b).length === 0) return -1
            return 0
          })
      )
    } else {
      const emptyIndex = productCompared.findIndex(
        e => Object.keys(e).length === 0
      )
      productCompared[
        emptyIndex > -1 ? emptyIndex : productCompared.length - 1
      ] = {
        _id: entrySummaryData?._id,
        image: entrySummaryData?.images[0],
        name: getTranslate(entrySummaryData?.name),
        catId: entrySummaryData?.catId,
        link:
          getTranslate(entrySummaryData?.slugs.value) +
          entrySummaryData?.slugs.postfix,
      }
      setProductCompares([...productCompared])
    }
    setIsOpenComparePopup(true)
    return
  }

  const scrollIntoEvaluate = () => {
    const element = document.getElementById('reviewAndRate')
    return element?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start',
    })
  }
  const indentText = () => {
    switch (entrySummaryData?.labelType) {
      case 'comingSoon':
        return 'indent-[138px]'

      default:
        return 'indent-[54px]'
    }
  }

  const outstandingFeature = useMemo(() => {
    if (entrySummaryData.outstandingFeatures)
      return (
        <OutstandingFeature
          outstandingFeatures={entrySummaryData.outstandingFeatures}
        />
      )
  }, [entrySummaryData.outstandingFeatures])

  return (
    <div className='entry-main w-full rounded-t-xl bg-white'>
      <div className='entry-title relative px-2 pb-3 pt-4'>
        <div className='relative'>
          <div className='absolute left-0 top-[-3px]'>
            <ProductLabel label={entrySummaryData?.labelType} />
          </div>
          <h1
            className={`mb-2 text-base font-bold leading-[22px] text-dark-800 ${indentText()}`}
          >
            {getTranslate(entrySummaryData?.name)}
          </h1>
        </div>
        <div className='flex items-center justify-between'>
          <div
            className='review-sec flex items-center justify-start gap-x-2 text-base text-dark-400'
            onClick={() => scrollIntoEvaluate()}
          >
            <div className='rating flex items-end leading-3'>
              {star(entrySummaryData?.rate)}
            </div>
            <div className='review mt-[2px] flex items-center gap-1 text-textSmall leading-3 text-dark-700'>
              {'('}
              <span className='review-label'>đánh giá</span> {')'}
            </div>
          </div>
        </div>
        {entrySummaryData?.flashSale && (
          <div
            onClick={() => handleAddToCompare()}
            className='absolute bottom-[-32px] right-2 cursor-pointer'
          >
            {isCompare() ? (
              <span
                className={`compare-label flex h-6 w-auto items-center gap-1 rounded-full bg-primary-base px-2 text-xs leading-6 text-white`}
              >
                <IconCompared />
                Đã thêm so sánh
              </span>
            ) : (
              <>
                <span className='flex h-6 items-center gap-1 rounded-full bg-primary-base px-2 text-xs leading-6 text-white'>
                  <IconCompared /> So sánh
                </span>
              </>
            )}
          </div>
        )}
        {!entrySummaryData?.flashSale && !isOutOfStock && (
          <>
            {entrySummaryData?.preOrder ? (
              <PreOrder
                priceAtWarehouse={entrySummaryData?.priceAtWarehouse}
                originPrice={entrySummaryData?.price}
                finalPrice={entrySummaryData?.finalPrice}
                flashSale={entrySummaryData?.flashSale}
                productId={entrySummaryData?._id}
                hasGift={
                  entrySummaryData?.gifts && entrySummaryData?.gifts?.length > 0
                }
                type='product-detail'
                layout='preOrder'
                preOrder={entrySummaryData?.preOrder}
                preOrderPrice={entrySummaryData?.preOrder?.salePrice}
              />
            ) : (
              <>
                <div className='relative mt-4 flex flex-col flex-wrap items-start'>
                  {!entrySummaryData?.flashSale && (
                    <div
                      onClick={() => handleAddToCompare()}
                      className='absolute right-0 top-0 cursor-pointer'
                    >
                      {isCompare() ? (
                        <span
                          className={`compare-label flex h-6 w-auto items-center gap-1 rounded-full bg-primary-base px-2 text-xs leading-6 text-white`}
                        >
                          <IconCompared />
                          Đã thêm so sánh
                        </span>
                      ) : (
                        <>
                          <span className='flex h-6 items-center gap-1 rounded-full bg-primary-base px-2 text-xs leading-6 text-white'>
                            <IconCompared /> So sánh
                          </span>
                        </>
                      )}
                    </div>
                  )}
                  <SalePrice
                    finalPrice={entrySummaryData?.finalPrice}
                    classes={
                      '!text-3xl font-extrabold leading-none text-dark-900 !mb-0'
                    }
                    type={PageType.PRODUCT}
                  />
                  <div className='flex items-center justify-start gap-x-2'>
                    <OriginPrice
                      type={PageType.PRODUCT}
                      originPrice={entrySummaryData?.price}
                      classes='text-base text-gray-800 leading-tight line-through'
                    />
                    {/* {percent > 0 && (
                      <span className='discount flex items-center gap-[2px]'>
                        <span className='flex items-center text-percent bg-primary-second leading-none font-light rounded-lg h-5 px-[2px] text-white text-sm'>
                          <span className='value'>-{percent}</span>
                          <span className='unit'>%</span>
                        </span>
                      </span>
                    )} */}
                  </div>
                </div>
              </>
            )}
          </>
        )}
        {isOutOfStock && !entrySummaryData?.flashSale && (
          <>
            <div className='my-3'>
              {/* <p className='label text-dark-900 text-sm font-bold leading-5 mt-2'>
                Giá bán
              </p> */}
              <SalePrice
                finalPrice={entrySummaryData?.finalPrice}
                classes={
                  'text-3xl font-extrabold leading-tight text-primary-second'
                }
                type={PageType.PRODUCT}
              />
              <div className='flex items-center justify-start gap-x-2'>
                <OriginPrice
                  type={PageType.PRODUCT}
                  originPrice={entrySummaryData?.price}
                  classes='text-base text-gray-800 leading-tight line-through'
                />
                {/* {percent > 0 && (
                  <span className='discount flex items-center gap-[2px]'>
                    <span className='flex items-center text-percent bg-primary-base font-light rounded-lg h-5 px-[2px] text-white text-sm'>
                      <span className='value'>-{percent}</span>
                      <span className='unit'>%</span>
                    </span>
                  </span>
                )} */}
              </div>
              <p className='mt-[5px] text-mainBody text-gray-100'>
                Liên hệ tư vấn, mua hàng{' '}
                <strong className='text-primary-second'>
                  {systemConfig?.companyHotline}
                </strong>
              </p>
            </div>
          </>
        )}
        <div
          className={`${
            stockStatus === ProductStockStatus.IN_STOCK
              ? 'text-green-800'
              : 'text-primary-second'
          } mt-1 text-xs font-bold leading-normal`}
        >
          {t(stockStatus)}
        </div>

        {/* <div className='after-title flex items-center justify-start mt-3 gap-x-2 text-base text-dark-400'>
          <div
            className={`${
              stockStatus === ProductStockStatus.IN_STOCK
                ? 'text-green-800'
                : 'text-primary-second'
            } text-xs font-black leading-normal`}
          >
            {t(stockStatus)}
          </div>

          {![
            ProductStockStatus.OUT_OF_STOCK,
            ProductStockStatus.OUT_OF_BUSINESS,
          ].includes(stockStatus as ProductStockStatus) && (
            <div
              onClick={() => {
                setIsOpenDraw(true)
                getListStore(
                  stockStatus === ProductStockStatus.IN_STOCK
                    ? { productId: entrySummaryData?._id }
                    : {}
                )
              }}
              className='flex items-center text-primary-base-500 text-sm font-normal leading-normal gap-x-1 cursor-pointer'
            >
              <LocationBlack />
              <span>Xem điểm lấy hàng</span>
            </div>
          )}
        </div> */}
      </div>
      {outstandingFeature}
      {((listService && listService?.length > 0) ||
        (listGift && listGift?.length > 0)) && (
        <div className='bg-white px-2 pb-3'>
          <div className='grid grid-cols-1 gap-2 rounded-lg bg-primary-base p-2'>
            {![
              ProductStockStatus.OUT_OF_STOCK,
              ProductStockStatus.OUT_OF_BUSINESS,
            ].includes(stockStatus as ProductStockStatus) && listGift ? (
              <Gift
                setListGift={setListGift}
                listGift={listGift}
                setListOffer={setListOffer}
                listOffer={listOffer}
                login={true}
              />
            ) : (
              ''
            )}
            {listService &&
            ![
              ProductStockStatus.OUT_OF_STOCK,
              ProductStockStatus.OUT_OF_BUSINESS,
            ].includes(stockStatus as ProductStockStatus) &&
            listService.length ? (
              <AccompaniedService
                setListService={setListService}
                productId={entrySummaryData?._id}
                productPrice={entrySummaryData?.finalPrice}
                listService={listService}
                pickUpInStore={pickUpInStore}
                setPickUpInStore={setPickUpInStore}
                receiveAtWarehouse={entrySummaryData?.receiveAtWarehouse}
                preOrderPrice={entrySummaryData?.preOrder?.salePrice}
                isPreOrder={isPreOrder}
                priceWithService={priceWithService}
                setPriceWithService={setPriceWithService}
              />
            ) : (
              ''
            )}
          </div>
        </div>
      )}

      {entrySummaryData?.otherInfos && (
        <div className='bg-white px-2 pb-3'>
          <div className='entry-addOtherInfo'>
            <div className=' w-full rounded-lg bg-zinc-300 px-2 py-2'>
              <ul className='flex w-full flex-wrap gap-1.5'>
                {entrySummaryData?.otherInfos?.map((item, idx) => {
                  return (
                    <li
                      className='item flex w-full items-start rounded bg-white px-2 py-2.5'
                      key={idx}
                    >
                      <Image
                        src={'/assets/icons/list.svg'}
                        width={20}
                        height={20}
                        alt='icon'
                        className='max-w-[20px] flex-[0_0_20px]'
                      />
                      <div className='text flex-auto pl-2'>
                        <span className='text-sm font-normal leading-normal'>
                          {getTranslate(item?.name)}
                        </span>{' '}
                        {item?.link && (
                          <Link
                            className='whitespace-nowrap text-xs font-normal text-primary-base'
                            href={item?.link || ''}
                          >
                            (Chi tiết)
                          </Link>
                        )}
                      </div>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>
      )}
      {entrySummaryData?.banners ? (
        <div className='w-full bg-white px-1 pb-2'>
          {entrySummaryData?.banners.length > 1 ? (
            <>
              <Swiper
                modules={[Grid, FreeMode, Autoplay]}
                className='!mx-[4px] overflow-hidden rounded-lg'
                slidesPerView={1}
                loop={true}
                spaceBetween={8}
                autoplay={{
                  delay: 3500,
                  disableOnInteraction: false,
                  stopOnLastSlide: true,
                }}
                speed={700}
              >
                {entrySummaryData?.banners?.map((item, idx) => (
                  <SwiperSlide key={'key' + idx}>
                    <Link
                      href={item?.link || ''}
                      className='block w-full cursor-pointer overflow-hidden rounded-lg'
                    >
                      <ImageOptimize
                        src={item?.image || ''}
                        alt={item?.title || ''}
                        className='w-full'
                      />
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            </>
          ) : (
            <Link
              href={entrySummaryData?.banners[0]?.link || ''}
              className='block w-full cursor-pointer px-[6px]'
            >
              <ImageOptimize
                src={entrySummaryData?.banners[0]?.image}
                alt={entrySummaryData?.banners[0]?.title}
                className='w-full overflow-hidden rounded-lg'
              />
            </Link>
          )}
        </div>
      ) : (
        ''
      )}
      <DrawBottom
        open={isOpenDraw}
        onClose={() => setIsOpenDraw(false)}
        title={'Chọn trung tâm'}
        scroll={true}
      >
        <div className='listLocation scrollBarCS flex h-full min-h-[calc(55svh-20px)] flex-row flex-wrap content-start justify-start gap-y-[12px] overflow-y-auto border-gray-100 pb-10 '>
          {globalLoading ? (
            <LoadingIndicator />
          ) : (
            storeList &&
            storeList.map((item, index) => (
              <button
                key={index}
                className={`${
                  storeSelected?._id === item._id && 'border-primary-second'
                } box-content block h-full min-h-[58px] w-full overflow-hidden rounded-lg border-[1px] border-gray px-2 outline-none`}
                onClick={() => {
                  setStoreSelected(item)
                  setIsOpenDraw(false)
                }}
              >
                <div className='flex items-start'>
                  <span
                    className={`mt-[2px] w-[30px] max-w-[30px] flex-[30px]`}
                  >
                    {storeSelected?._id === item._id ? (
                      <SelectedIcon />
                    ) : (
                      <span className='block h-[16px] w-[16px] overflow-hidden rounded-[100%] border border-dark-700'></span>
                    )}
                  </span>
                  <div className='flex flex-1 flex-row flex-wrap items-start justify-start gap-[2px] text-left'>
                    <p className={'block w-full text-mainBody font-bold'}>
                      {getTranslate(item.name)}
                    </p>
                    <p className='block w-full text-textSmall text-dark-500'>
                      {item.fullAddress}
                    </p>
                  </div>
                </div>
              </button>
            ))
          )}
        </div>
      </DrawBottom>
      <DrawBottom
        open={isOpenContact || false}
        onClose={() => setIsOpenContact(false)}
        scroll={true}
      >
        <div className='listLocation flex h-full flex-row flex-wrap content-start  justify-start gap-y-[12px] border-gray-100 pb-10 '>
          <Formik
            initialValues={{
              phone: '',
              name: '',
              provinceCode: '',
            }}
            validationSchema={translateSchema('contact', t)}
            onSubmit={async values => {
              await sendContact({
                ...values,
                productIds: [entrySummaryData?._id],
              }).then(() => {
                toast.success('Gửi yêu cầu thành công', {
                  position: 'bottom-center',
                  icon: <IconCheckedSuccess />,
                  autoClose: 1500,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                  progress: undefined,
                  theme: 'dark',
                })
              })
              setIsOpenContact(false)
              return
            }}
          >
            {props => (
              <Form onSubmit={props.handleSubmit}>
                <span className='text-sm italic leading-4 text-dark-400'>
                  Quý khách vui lòng để lại thông tin, chúng tôi sẽ gọi lại tư
                  vấn trong thời gian sớm nhất.
                </span>
                <div className='mt-[20px]'>
                  <FormGroup className='mb-3 flex w-full flex-col'>
                    <FormInput
                      name='name'
                      placeholder='Họ và tên'
                      value={props.values.name}
                      onChange={props.handleChange}
                      alert
                      className={clsx(
                        props.errors.name && 'border border-primary-second',
                        'rounded-lg border border-border-500 bg-white-500 text-base transition hover:cursor-pointer focus:border-primary-base disabled:bg-gray-200 disabled:text-dark-400/50'
                      )}
                    ></FormInput>
                    {props.errors.name && (
                      <FormTextRequire className=' text-sm font-normal text-primary-second'>
                        {props.errors.name as string}
                      </FormTextRequire>
                    )}
                  </FormGroup>
                  <FormGroup className='mb-3 flex w-full flex-col'>
                    <FormInput
                      name='phone'
                      placeholder='Nhập số điện thoại'
                      value={props.values.phone}
                      onChange={e => {
                        props.handleChange({
                          target: {
                            value: e.target.value.trim().replace(/\D/, ''),
                            name: 'phone',
                          },
                        })
                      }}
                      alert
                      className={`rounded-lg border border-border-500 bg-white-500 text-base transition hover:cursor-pointer focus:border-primary-base disabled:bg-gray-200 disabled:text-dark-400/50`}
                    />
                    {props.errors.phone && (
                      <FormTextRequire className=' text-sm font-normal text-primary-second'>
                        {props.errors.phone as string}
                      </FormTextRequire>
                    )}
                  </FormGroup>
                  <FormGroup className='mb-5 flex w-full flex-col'>
                    <FormAddress
                      onChange={e => {
                        props.handleChange({
                          target: {
                            value: e.target.value,
                            name: 'provinceCode',
                          },
                        })
                      }}
                      value={props.values.provinceCode}
                      placeholder={'Chọn Tỉnh/Thành Phố'}
                      title={'Chọn Tỉnh/Thành Phố'}
                      placeholderSearch={'Tìm nhanh tỉnh/thành Phố'}
                      name='provinceCode'
                      className='w-full'
                      classSelectButtonName={clsx(
                        props.errors.provinceCode &&
                          'border border-primary-second',
                        'bg-white-500 border border-border-500 text-center'
                      )}
                      isError={props.errors.provinceCode}
                      data={provinces}
                    />
                    {props.errors.provinceCode ? (
                      <FormTextRequire className=' text-sm font-normal text-primary-second'>
                        {props.errors.provinceCode as string}
                      </FormTextRequire>
                    ) : (
                      ''
                    )}
                  </FormGroup>
                  <FormButton
                    className={`h-[54px] w-full overflow-hidden rounded-lg bg-primary-base text-base font-semibold text-white outline-none`}
                  >
                    Xác nhận
                  </FormButton>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </DrawBottom>
    </div>
  )
}
